export type FlockV3Sort = 'asc' | 'desc';

/**
 * Interface for Flock V3 LPR search parameters.
 *
 * Backend:
 * - Path: <TO_BE_FILLED> (TODO: BE Implemenetation https://taserintl.atlassian.net/browse/AXFS-1334)
 * - Class: <TO_BE_FILLED> (TODO: BE Implemenetation https://taserintl.atlassian.net/browse/AXFS-1334)
 */
export interface IFsLprFlockV3Parameters {
  // Pagination/sorting
  pageSize?: number;
  maxResults?: number;
  sortOrder?: FlockV3Sort;
  pageId?: string;
  reason?: string;
  plateState?: string;
  caseNumber?: string;

  // General
  plate?: string;
  fromDate?: string;
  toDate?: string;

  // Additional
  /**
   * TODO: VERIFY what is supported for Flock V3
   * FWX-2729: https://taserintl.atlassian.net/browse/FWX-2729
   * Below is what is supported for Flock V1:
   * Flock V1 only support 2 commas seperated coordinates that form a box
   * @url https://axon.quip.com/XNl4AMLfwayD/ALPR-Provider-Geo-Search-Limitations#temp:C:SJbda20bdaf0a7440019c84443de
   */
  inBbox?: string;

  // Geo search parameters - alternative to bbox
  point?: string; // Format: "longitude,latitude"
  radius?: number; // Radius in meters
}
